

















































































































































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	ref,
} from '@vue/composition-api';
import { canEditDiscussionMessage, canRemoveDiscussionMessage, canRestoreDiscussionMessage } from '@front-app/util/permission/discussion';
import { Size } from '@front-app/components/constants';
import { useDiscussionMessageStore } from '@front-app/store/piniaModules/discussionMessages';
import { DiscussionMessage, ContentType } from '@front-app/services/GroupsApi/DiscussionModel';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { getUsername } from '@front-app/util/user';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useReactionButtons } from '@front-app/components/buttons/useReactionButtons';
import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import NoteButton from '@front-app/components/buttons/NoteButton.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import ReactionsListDropdown from '@front-app/components/dropdowns/ReactionsListDropdown.vue';
import AddReactionDropdown from '@front-app/components/dropdowns/AddReactionDropdown.vue';
import SimpleCard from '../SimpleCard.vue';

export default defineComponent({
	components: {
		AddReactionDropdown,
		CtaButton,
		EditButton,
		NoteButton,
		ReactionsListDropdown,
		SimpleCard,
		UserAvatar,
		UserLink,
		XButton,
	},
	props: {
		content: {
			type: Object as PropType<DiscussionMessage>,
			required: true,
		},
		compact: Boolean,
	},
	setup(props, ctx) {
		const discussionMessageStore = useDiscussionMessageStore();
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);
		const expanded = ref(false);

		const canRemovePost = computed(() => canRemoveDiscussionMessage(props.content));
		const {
			track: trackRemoval,
			isLoading: isRemoving,
			isError: hasErrorRemoving,
		} = useAsyncStatus();
		const removePost = async () => {
			await trackRemoval(discussionMessageStore.remove(props.content.id));
		};

		const canRestorePost = computed(() => canRestoreDiscussionMessage(props.content));
		const {
			track: trackRestoration,
			isLoading: isRestoring,
			isError: hasErrorRestoring,
		} = useAsyncStatus();
		const restorePost = async () => {
			await trackRestoration(discussionMessageStore.restore(props.content.id));
		};
		const canEditPost = computed(() => canEditDiscussionMessage(props.content));

		// Reactions
		const contentReactions = computed(() => props.content.reactions);
		const { reactionButtons } = useReactionButtons(contentReactions);
		const activeReactionButtons = computed(() => reactionButtons.value.filter((reactionButton) => reactionButton?.count > 0));

		// Responsive view
		const screenWidth = ref(window.innerWidth);
		onMounted(() => {
			window.onresize = () => {
				screenWidth.value = window.innerWidth;
			};
		});
		// eslint-disable-next-line arrow-body-style
		const getUserAvatarSize = () => {
			return screenWidth.value < 810 ? Size.MEDIUM : Size.LARGE;
		};

		return {
			// Edit post
			canEditPost,
			// Remove post
			canRemovePost,
			removePost,
			isRemoving,
			hasErrorRemoving,
			// Restore post
			canRestorePost,
			isRestoring,
			hasErrorRestoring,
			restorePost,
			// Compact view
			expanded,
			// Avatar
			getUserAvatarSize,
			getUsername: getUsernameInternal,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			// Reactions
			ContentType,
			activeReactionButtons,
			reactionButtons,
			// Util / Constants
			Size,
			ButtonPalettes,
		};
	},
});
